var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rkm-content',[_c('rkm-content-header',{attrs:{"title":_vm.$route.meta.title}}),_c('rkm-content-body',[_c('rkm-container',[_c('List')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }